module.exports = "/_next/static/images/7bfa3130bff5febc1392902a69c67124-rewards-smiles@0.5x.png";